module.exports = __webpack_public_path__ + "img/item5-1.d439f30b.jpg";